import type { TrainingPackageCredit } from '@/lib/marketing';

async function jsonFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
    credentials: 'include',
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`HTTP ${response.status} ${response.statusText}: ${text || path}`);
  }

  return response.json() as Promise<T>;
}

export const TrainingPackageService = {
  listCredits(): Promise<TrainingPackageCredit[]> {
    return jsonFetch('/api/training/package-credits');
  },
};
